import {mapActions} from 'vuex'

export default {
  async created() {
    await this.getBankList()
    await this.updateGlobalOptions()
    this.updateAllOptions()
    this.updateAllOptions(11)
    this.updateAllOptions(12)
    this.updateAllOptions(13)
    this.updateAllOptions(15)
    this.updateAllOptions(21) // housemaid
    this.updateAllOptions(22) // working
    this.updateAllOptions(23) // 旅游 Travel
    this.updateAllOptions(24) // 室外裝飾
    this.updateAllOptions(25) // 海外留學
    this.updateAllOptions(26) // 家居
    this.updateAllOptions(29) // 個人意外
    this.updateAllOptions(27) // 火險
    this.updateAllOptions(31) // 火險
    this.updateCustomerOptions()
    this.updateNewSMEOptions()
    const smeProductList = [81,82,83,84,85,86,88]
    smeProductList.some(smeProductId => {
      this.updateSMEOptions(smeProductId)
    })
    const specialOptionList = ['marketing_data', 'source', 'quote_tag', 'renew_product_type', 'ticket_class_type','lecture_session','verify_type']
    specialOptionList.forEach(option => {
      this.setSpecialOptions(option)
    })
    this.updateCarClassOptions()
  },
  methods: {
    ...mapActions('common', ['updateAllOptions', 'updateGlobalOptions', 'updateCustomerOptions','getBankList','updateExtraOptions','updateSMEOptions','setSpecialOptions','updateCarClassOptions','updateNewSMEOptions']),
  }
}
